define(["require", "exports", "tslib", "mobx", "../EntityBase", "../../utils/EntityUtil", "../entity/WaDoc"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityUtil_1, WaDoc_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FacilityWaterAgreementHistoryRecord = void 0;
    class FacilityWaterAgreementHistoryRecord extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "AnnualFee", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AnnualFeeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Documents", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DocumentsError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Landowner", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LandownerError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgaContactEmail", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgaContactEmailError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgaContactName", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgaContactNameError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgaContactPhone", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgaContactPhoneError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RefId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RefIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SgoContactEmail", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SgoContactEmailError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SgoContactName", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SgoContactNameError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SgoContactPhone", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SgoContactPhoneError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Status", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StockType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StockTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Type", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "TypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, FacilityWaterAgreementHistoryRecord.ObservableFields);
        }
        onCreate() {
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
        }
        onRead(entity) {
            if (!isNaN(entity.AnnualFee)) {
                this.AnnualFee = (0, EntityUtil_1.toInt)(entity.AnnualFee);
            }
            this.Documents = [];
            if (entity.Documents) {
                for (let i = 0; i < entity.Documents.length; i++) {
                    this.Documents[i] = new WaDoc_1.WaDoc(entity.Documents[i]);
                }
            }
            if (!isNaN(entity.Id)) {
                this.Id = (0, EntityUtil_1.toInt)(entity.Id);
            }
            if (entity.Landowner) {
                this.Landowner = entity.Landowner;
            }
            if (entity.LgaContactEmail) {
                this.LgaContactEmail = entity.LgaContactEmail;
            }
            if (entity.LgaContactName) {
                this.LgaContactName = entity.LgaContactName;
            }
            if (entity.LgaContactPhone) {
                this.LgaContactPhone = entity.LgaContactPhone;
            }
            if (entity.RefId) {
                this.RefId = entity.RefId;
            }
            if (entity.SgoContactEmail) {
                this.SgoContactEmail = entity.SgoContactEmail;
            }
            if (entity.SgoContactName) {
                this.SgoContactName = entity.SgoContactName;
            }
            if (entity.SgoContactPhone) {
                this.SgoContactPhone = entity.SgoContactPhone;
            }
            if (entity.Status) {
                this.Status = entity.Status;
            }
            if (entity.StatusDate) {
                this.StatusDate = entity.StatusDate;
            }
            if (entity.StockType) {
                this.StockType = entity.StockType;
            }
            if (entity.Type) {
                this.Type = entity.Type;
            }
        }
        onReady() {
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.AnnualFee = typeof b.AnnualFee != "number" ? (0, EntityUtil_1.toFloat)(b.AnnualFee) : b.AnnualFee;
            a.Documents = this.mergeArray(a.Documents, b.Documents, WaDoc_1.WaDoc);
            a.Id = b.Id;
            a.Landowner = b.Landowner;
            a.LgaContactEmail = b.LgaContactEmail;
            a.LgaContactName = b.LgaContactName;
            a.LgaContactPhone = b.LgaContactPhone;
            a.RefId = b.RefId;
            a.SgoContactEmail = b.SgoContactEmail;
            a.SgoContactName = b.SgoContactName;
            a.SgoContactPhone = b.SgoContactPhone;
            a.Status = b.Status;
            a.StatusDate = b.StatusDate;
            a.StockType = b.StockType;
            a.Type = b.Type;
            this.postMerge();
        }
        postMerge() {
        }
        serialise() {
            return JSON.stringify(this);
        }
        hasChanges() {
            return this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED;
        }
        validate() {
            return null;
        }
        toJson() {
            return {
                AnnualFee: this.AnnualFee,
                Documents: this.Documents.map(x => x.toJson()),
                Id: this.Id,
                Landowner: this.Landowner,
                LgaContactEmail: this.LgaContactEmail,
                LgaContactName: this.LgaContactName,
                LgaContactPhone: this.LgaContactPhone,
                RefId: this.RefId,
                SgoContactEmail: this.SgoContactEmail,
                SgoContactName: this.SgoContactName,
                SgoContactPhone: this.SgoContactPhone,
                Status: this.Status,
                StatusDate: this.StatusDate,
                StockType: this.StockType,
                Type: this.Type,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
    }
    exports.FacilityWaterAgreementHistoryRecord = FacilityWaterAgreementHistoryRecord;
    Object.defineProperty(FacilityWaterAgreementHistoryRecord, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["AnnualFee", "Documents", "Id", "Landowner", "LgaContactEmail", "LgaContactName", "LgaContactPhone", "RefId", "SgoContactEmail", "SgoContactName", "SgoContactPhone", "Status", "StatusDate", "StockType", "Type"]
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityWaterAgreementHistoryRecord.prototype, "AnnualFee", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityWaterAgreementHistoryRecord.prototype, "AnnualFeeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityWaterAgreementHistoryRecord.prototype, "Documents", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityWaterAgreementHistoryRecord.prototype, "DocumentsError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityWaterAgreementHistoryRecord.prototype, "Landowner", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityWaterAgreementHistoryRecord.prototype, "LandownerError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityWaterAgreementHistoryRecord.prototype, "LgaContactEmail", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityWaterAgreementHistoryRecord.prototype, "LgaContactEmailError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityWaterAgreementHistoryRecord.prototype, "LgaContactName", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityWaterAgreementHistoryRecord.prototype, "LgaContactNameError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityWaterAgreementHistoryRecord.prototype, "LgaContactPhone", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityWaterAgreementHistoryRecord.prototype, "LgaContactPhoneError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityWaterAgreementHistoryRecord.prototype, "RefId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityWaterAgreementHistoryRecord.prototype, "RefIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityWaterAgreementHistoryRecord.prototype, "SgoContactEmail", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityWaterAgreementHistoryRecord.prototype, "SgoContactEmailError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityWaterAgreementHistoryRecord.prototype, "SgoContactName", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityWaterAgreementHistoryRecord.prototype, "SgoContactNameError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityWaterAgreementHistoryRecord.prototype, "SgoContactPhone", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityWaterAgreementHistoryRecord.prototype, "SgoContactPhoneError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityWaterAgreementHistoryRecord.prototype, "Status", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityWaterAgreementHistoryRecord.prototype, "StatusError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityWaterAgreementHistoryRecord.prototype, "StatusDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityWaterAgreementHistoryRecord.prototype, "StatusDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityWaterAgreementHistoryRecord.prototype, "StockType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityWaterAgreementHistoryRecord.prototype, "StockTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityWaterAgreementHistoryRecord.prototype, "Type", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityWaterAgreementHistoryRecord.prototype, "TypeError", void 0);
});
